import { forwardRef } from 'react';
import styled from 'styled-components';
import IconButton from './IconButton';
import useOutsideClick from 'utils/useOutsideClick';
import ReactDOMServer from 'react-dom/server';

const ToolbarEnabler = forwardRef((props, ref) => {
  const {
    className,
    bounds,
    onClickOutside,
    onClick,
  } = props;

  const wrapperRef = useOutsideClick(onClickOutside);

  const assignRefs = (element) => {
    ref.current = element;
    wrapperRef.current = element;
  };

  const hintContent = ReactDOMServer.renderToStaticMarkup(
    <HintContent>
      <div>Toolbar</div>
      <div><HintKey>⌘</HintKey> <HintKey>L</HintKey></div>
    </HintContent>
  );

  return (
    <Wrapper onClick={onClick} ref={assignRefs} bounds={bounds}>
      <IconButton
        className={className}
        icon='lizzy-logo-btn'
        tooltipHtml={hintContent}
        tooltipDelayShow={1000}
      />
    </Wrapper>
  );
});

export default ToolbarEnabler

const Wrapper = styled.div`
  position: absolute;
  left: ${p => (p.bounds?.x + 5) || 0}px;
  top: ${p => (p.bounds?.top - 1) || 0}px;
  z-index: 2;
  filter: drop-shadow(0px -10px 27px rgba(0, 0, 0, 0.09))
    drop-shadow(0px 3.75998px 11.28px rgba(0, 0, 0, 0.0503198))
    drop-shadow(0px 2.01027px 6.0308px rgba(0, 0, 0, 0.0417275))
    drop-shadow(0px 1.12694px 3.38082px rgba(0, 0, 0, 0.035))
    drop-shadow(0px 0.598509px 1.79553px rgba(0, 0, 0, 0.0282725))
    drop-shadow(0px 0.249053px 0.747159px rgba(0, 0, 0, 0.0196802));

  ${IconButton} {
    &:hover {
      opacity: 1;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }

  &.fade-enter {
    transform-origin: center;
    transform: scale(0);
  }

  &.fade-enter-active {
    transform: scale(1);
    transition: transform .2s cubic-bezier(0.25, 0.1, 0.37, 1.58);
  }

  &.fade-exit {
    transform-origin: center;
    transform: scale(1);
    transition: transform .2s ease-out;
  }

  &.fade-exit-active {
    transform: scale(0);
  }
`;

const HintContent = styled.div`
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const HintKey = styled.span`
  display: inline-block;
  background-color: var(--lizzy-black-35);
  color: var(--lizzy-white);
  border-radius: 3px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-weight: 600;
`